// extracted by mini-css-extract-plugin
module.exports = {"ButtonsBar":"DataCollection_ButtonsBar__1B-7V","exportSubmenu":"DataCollection_exportSubmenu__3gEWY"};